import { render, staticRenderFns } from "./MaterialModel.vue?vue&type=template&id=7c82ff34&scoped=true&"
import script from "./MaterialModel.vue?vue&type=script&lang=js&"
export * from "./MaterialModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c82ff34",
  null
  
)

export default component.exports